<template>
    <div class="about">
        <headerCom></headerCom>
        <div class="width title-box">
            <p class="title">招聘信息</p>
            <p class="line">—</p>
            <p class="title-en">RECRUITMENT INFORMATION</p>
        </div>
        <div class="list-box">
            <div
                v-for="(item, index) in positionList"
                class="item-box"
                :key="index"
                :class="index % 2 == 0 ? 'right' : 'left'"
                @click="linkTo('/recruitDetail')"
            >
                <!--  v-if="" right-->
                <div class="img-box" v-if="index % 2 != 0">
                    <p>
                        <span class="up">JAVA</span>
                        <span class="down"> DEVELOPMENT</span>
                    </p>
                    <!-- <img src="../assets/images/top01.png" alt=""/> -->
                    <img src="../assets/images/top02.png" alt="" v-if="index==1"/>
                    <img src="../assets/images/top04.png" alt="" v-if="index==3"/>
                </div>
                <div class="info-box">
                    <div>
                        <p class="name">{{ item.name }}</p>
                        <p class="content">{{ item.content }}</p>
                        <p class="content-En">{{ item.contentEn }}</p>
                    </div>
                </div>
                <div class="img-box" v-if="index % 2 == 0">
                    <p>
                        <span class="up">JAVA</span>
                        <span class="down"> DEVELOPMENT</span>
                    </p>
                    <img src="../assets/images/top01.png" alt="" v-if="index==0"/>
                    <img src="../assets/images/top03.png" alt="" v-if="index==2"/>
                </div>
            </div>
        </div>
        <div>
            <img src="../assets/images/join-us.jpg" alt="">
        </div>
        <!-- <img src="" alt="" srcset=""> -->
        <!-- <footerCom></footerCom> -->
    </div>
</template>
<script>
import headerCom from "../components/header";
import footerCom from "../components/Footer";
import { positionListByPage } from "../api/newstendency.js";

export default {
    name: "newstendency",
    components: {
        // footerCom,
        headerCom,
    },
    data() {
        return {
            httpUrl: process.env.VUE_APP_URL,
            pagination: {
                pageSize: 10,
                currentPage: 1,
                total: null,
            },
            positionList: [
                {
                    name: "JAVA开发",
                    nameEn: "JAVA DEVELOPMENT",
                    content:
                        "1. 负责公司软件产品开发或项目系统开发；2. 依据需求文档，完成需求分析，设计、编码、单元和集成...",
                    contentEn:
                        "1. Be responsible for the planning, design and product implementation of independent product lines; 2. Responsible for market research, data analysis, competitive ...",
                    img: "../assets/images/about-top.png",
                },{
                    name: "前端开发",
                    nameEn: "FRONT END DEVELOPMENT",
                    content:
                        "1.负责系统前端开发工作，协调界面设计师和开发人员的工作；2.优化网站前端功能设计，解决各种浏...",
                    contentEn:
                        "1. Be responsible for the front-end development of the system and coordinate the work of interface designers and developers; 2. Optimize the front-end function ",
                    img: "../assets/images/about-top.png",
                },{
                    name: "产品经理",
                    nameEn: "FRONT END DEVELOPMENT",
                    content:
                        "1.负责独立产品线的规划、设计和产品落地执行；2、负责市场调研，数据分析，竞品分析，价值分析；",
                    contentEn:
                        "1. Be responsible for the planning, design and product implementation of independent product lines; 2. Responsible for market research, data analysis, competitive ...",
                    img: "../assets/images/about-top.png",
                },{
                    name: "JAVA开发",
                    nameEn: "JAVA DEVELOPMENT",
                    content:
                        "1. 负责公司软件产品开发或项目系统开发；2. 依据需求文档，完成需求分析，设计、编码、单元和集成...",
                    contentEn:
                        "1. Be responsible for the planning, design and product implementation of independent product lines; 2. Responsible for market research, data analysis, competitive ...",
                    img: "../assets/images/about-top.png",
                },
            ],
        };
    },
    methods: {
        // 跳转
        linkTo(path, id) {
            this.$router.push({
                path: path,
                /* query: {
                    id: id,
                }, */
            });
        },

        handleCurrentChange(currentPage) {
            // console.log(currentPage);
            this.pagination.currentPage = currentPage;
            this.positionListByPageFun();
        },

        //列表
        positionListByPageFun() {
            positionListByPage(this.pagination)
                .then((res) => {
                    if (res.code == 200) {
                        this.positionList = res.data.list;
                        this.pagination.total = res.data.total;
                    }
                })
                .catch((err) => {
                    this.$message(err.message);
                });
        },
    },
    created() {
        this.pagination.currentPage = 1;
        this.positionListByPageFun();
    },
};
</script>
<style lang="less" scoped>
.about {
    width: 100%;
    min-height: 790px;
    background-color: #f8f8f8;
    .top {
        width: 100%;
        position: relative;
        .nav-box {
            position: absolute;
            top: 12px;
            left: 50%;
            transform: translateX(-50%);
            -webkit-transform: translateX(-50%); /* for Chrome || Safari */
            -moz-transform: translateX(-50%); /* for Firefox */
            -ms-transform: translateX(-50%); /* for IE */
            -o-transform: translateX(-50%); /* for Opera */
            height: 55px;
            z-index: 2000;
            padding-left: 20px;
            // padding-right: 50px;
            .logo {
                height: 55px;
                width: 137px;
                display: block;
                float: left;
            }
            color: #cccccc;
            font-size: 16px;
            .nav {
                float: right;
                height: 25px;
                line-height: 25px;
                margin-top: 15px;
                cursor: pointer;
                p {
                    float: left;
                    padding: 0 20px;
                }
            }
        }
    }

    .title-box {
        // position: relative;
        width: 100%;
        padding-bottom: 25px;
        // background-color: #ffffff;
        // border-bottom: 2px solid #d6dcea;
        p {
            text-align: center;
        }
        .title {
            padding-top: 25px;
            font-size: 28px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #345197;
        }
        .line {
            font-size: 28px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #345197;
            height: 20px;
            line-height: 20px;
        }
        .title-en {
            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #345197;
        }
    }
    .list-box {
        width: 100%;
        // padding-bottom: 500px;
        display: flex;
        flex-direction: column;

        .item-box{
            margin-bottom: 2px;
        }

        .right {
            width: 100%;
            height: 350px;
            // border-bottom: 1px solid #d6dcea;
            background-color: #ffffff;
            // padding: 0px 130px;
            padding-left: 130px;

            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .info-box {
                width: 50%;
                display: flex;
                align-items: center;
                // padding: 50px 0;
                div {
                    // background-color: red;
                    .name {
                        font-size: 18px;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #000000;
                    }
                    .content {
                        font-size: 16px;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #666666;

                        padding: 20px 0;
                        border-bottom: 1px solid #e5e5e5;
                    }
                    .content-En {
                        font-size: 12px;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #999999;
                        margin-top: 20px;
                    }
                }
            }
            .img-box {
                width: 300px;
                // height: 100%;
                background-color: #2e4c8c;
                color: #8390b3;
                position: relative;
                display: flex;
                p {
                    font-size: 32px;
                    font-weight: 800;
                    .up {
                        font-size: 32px;
                        font-weight: 800;
                        position: absolute;
                        left: 10px;
                        bottom: 40px;
                        line-height: 30px;
                    }
                    .down {
                        font-size: 32px;
                        font-weight: 800;
                        position: absolute;
                        left: 30px;
                        bottom: 10px;
                        line-height: 30px;
                    }
                }
                img {
                    width: 230px;
                    height: 230px;
                    position: absolute;
                    top: 30px;
                    left: -130px;
                }
            }
        }

        .left {
            width: 100%;
            height: 350px;
            // border-bottom: 1px solid #d6dcea;
            background-color: #ffffff;
            // padding: 0px 130px;
            padding-right: 130px;

            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .info-box {
                width: 50%;
                display: flex;
                align-items: center;
                // padding: 50px 0;
                div {
                    // background-color: red;
                    .name {
                        font-size: 18px;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #000000;
                    }
                    .content {
                        font-size: 16px;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #666666;

                        padding: 20px 0;
                        border-bottom: 1px solid #e5e5e5;
                    }
                    .content-En {
                        font-size: 12px;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #999999;
                        margin-top: 20px;
                    }
                }
            }
            .img-box {
                width: 300px;
                // height: 100%;
                background-color: #2e4c8c;
                color: #8390b3;
                position: relative;
                display: flex;
                p {
                    font-size: 32px;
                    font-weight: 800;
                    .up {
                        font-size: 32px;
                        font-weight: 800;
                        position: absolute;
                        left: 10px;
                        bottom: 40px;
                        line-height: 30px;
                    }
                    .down {
                        font-size: 32px;
                        font-weight: 800;
                        position: absolute;
                        left: 30px;
                        bottom: 10px;
                        line-height: 30px;
                    }
                }
                img {
                    width: 230px;
                    height: 230px;
                    position: absolute;
                    top: 30px;
                    right: -130px;
                }
            }
        }
    }
}
/deep/ .el-pagination {
    margin-top: 50px;
    text-align: end;
}
@media screen and (max-width: 1650px) {
    .about .title-box .tips-box {
        font-size: 16px;
    }
    .about .title-box .tips-box img {
        width: 14px;
    }
}
@media screen and (max-width: 1450px) {
    .about .title-box .tips-box {
        font-size: 14px;
    }
    .about .title-box .tips-box img {
        width: 12px;
    }
}

/deep/.el-timeline-item__tail {
    // top: 50%;
    top: 0;
    left: 7px;
    padding-top: 10%;
    display: block !important;
}
/deep/ .el-timeline-item__node {
    top: calc(50% - 20px);
    background: url(../assets/images/line-time.png) no-repeat center center;
    background-size: 100% 100%;
    width: 18px;
    height: 18px;
    // margin-bottom: 10px;
}
</style>

<style>
.el-popper .popper__arrow::after {
    content: none;
}
.el-popper[x-placement^="bottom"] {
    margin-top: 0;
    margin-right: -30px;
    /* padding: 0 20px; */
}
.el-popper[x-placement^="bottom"] .popper__arrow {
    display: none;
}
.el-dropdown-menu {
    position: absolute;
    top: 0;
    left: 0;
    padding: 10px 0;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.3);
    border: none;
    border-radius: 0;
    box-shadow: none;
}
.el-dropdown-menu__item {
    color: #ccc;
    width: 110px;
    text-align: center;
    background-color: rgba(0, 0, 0, 0) !important;
}
.el-dropdown-menu__item:hover {
    background-color: rgba(0, 0, 0, 0);
}
.el-dropdown-menu__item:focus {
    background-color: rgba(0, 0, 0, 0);
}
.el-dropdown {
    color: #ccc;
    font-size: 16px;
}
</style>

